app.modules.animatedMenu = ((self = {}) => {
  const _hamburgerButton = document.querySelector('.js-animated-menu');
  const _toolbarContainer = document.querySelector('.js-toolbar-container');

  function _toggleMenuState() {
    _hamburgerButton.classList.toggle('animated-menu_active');
    _toolbarContainer.classList.toggle(
      'main-header__toolbar-container_animated-menu-open'
    );
  }

  function _addListeners() {
    _hamburgerButton.addEventListener('click', _toggleMenuState);
    document.addEventListener('animatedMenu:close', _toggleMenuState);
  }

  self.load = _addListeners;
  return self;
})(app.modules.animatedMenu);
